import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import MakerNavigation from "./gapsy-Mnavigation";
import CheckerNavigation from "./gapsy-Cnavigation";
import AdminNavigation from "./gapsy-Anavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { uploadMutiple, Bulkuploaddata, previewrdmdata, checkboxapprove, shariahmappingdata, updatetextfile3001, checkboxreject } from '../components/ApiProperty';
import { Modal, Button } from 'react-bootstrap';
import { submitButtonStyle, cancelButtonStyle, ProceedButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GapsyShariahDescription from "../components/GapsyShariahDescription";


const GapsyShariahReport = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState("");
    const [tempData, setTempData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [makerRemarks, setMakerRemarks] = useState("");
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [isViewMode, setIsViewMode] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason, setRejectedReason] = useState("");
    const [showDownload, setShowDownload] = useState(false);
    const [reportingDates, setReportingDates] = useState([]);
    const [q1, setQ1] = useState("");
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    const [reportingDate, setReportingDate] = useState("");
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [gradeRows, setGradeRows] = useState([]);
    const [excelLoaded, setExcelLoaded] = useState(false);
    const [capitalChargeData, setCapitalChargeData] = useState([]);
    const [capitalChargeAmount, setCapitalChargeAmount] = useState("");



    useEffect(() => { loadExcel(); }, []);

    const fmt = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            if (val > 0 && val < 1) return (val * 100).toFixed(0) + "%";
            return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
        }
        return String(val);
    };

    const navigationMap = {
        Maker: MakerNavigation,
        Checker: CheckerNavigation,
        Admin: AdminNavigation,
    };

    const userRole = localStorage.getItem("userRole");

    const Navigation = navigationMap[userRole] || CheckerNavigation;

    useEffect(() => {
        fetchPreviewData();
    }, []);

    const loadReportingDateData = async (quarter) => {

        if (!quarter) {
            handleReset();
            setMakerRemarks("");
            setIsViewMode(false);
            return;
        }

        const reportDate = getReportingDate(quarter);

        // Get mapping API data
        const mappingData = (await loadShariahMapping(reportDate)) || [];

        console.log("mappingData length:", mappingData.length);
        console.log(mappingData);

        const hasMapping = mappingData.length > 0;

        console.log("mappingData length:", mappingData.length);
        console.log(mappingData);

        if (!hasMapping) {
            restoreExcelValues();
        }

        // ---------------------------------------
        // Get TEMP records for selected date
        // ---------------------------------------
        const records = liveData
            .filter(
                row =>
                    row.reporting_date === reportDate &&
                    isNullValue(row.Rejected_Reason)
            )
            .sort((a, b) => Number(a.rowId) - Number(b.rowId));

        console.log("TEMP RECORDS:", records);
        console.log("TEMP RECORD COUNT:", records.length);

        handleReset();

        if (records.length === 0) {
            setMakerRemarks("");
            setIsViewMode(false);
            return;
        }

        // ---------------------------------------
        // Quarter values
        // ---------------------------------------
        const first = records[0];

        setQ1(
            first.quarter1 === "\\N"
                ? ""
                : first.quarter1
        );

        setQ2(
            first.quarter2 === "\\N"
                ? ""
                : first.quarter2
        );

        setQ3(
            first.quarter3 === "\\N"
                ? ""
                : first.quarter3
        );

        const remarks = records.find(
            r => !isNullValue(r.Maker_Remarks)
        )?.Maker_Remarks || "";

        setMakerRemarks(remarks);

        if (records.length === 0) {
            handleReset();
            setIsViewMode(false);
            return;
        }
        // Operational Risk Charge
        // ---------------------------------------
        const chargeRow = records.find(r =>
            (r.particulars || "").includes("Operational Risk")
        );

        if (chargeRow) {
            setOperationalRiskCharge(
                chargeRow.amount === "\\N"
                    ? ""
                    : chargeRow.amount
            );
        }

        // ---------------------------------------
        // Capital Charge for Shariah Risk
        // ---------------------------------------
        const capitalChargeRow = records.find(
            r =>
                (r.particulars || "").trim() ===
                "Capital Charge for Shariah Risk"
        );

        setCapitalChargeAmount(
            capitalChargeRow?.amount === "\\N"
                ? ""
                : capitalChargeRow?.amount || ""
        );

        // =====================================================
        // UPDATE INDEX ROWS
        // TEMP DATA ONLY
        // =====================================================

        const updatedRows = records
            .filter(r => {
                const keyArea = (r.key_areas || "").trim();

                return (
                    keyArea &&
                    keyArea.toLowerCase() !== "total"
                );
            })
            .map(dbRow => {

                const keyArea =
                    (dbRow.key_areas || "").trim();

                return {

                    keyArea: keyArea,

                    // -----------------------------
                    // Weight
                    // -----------------------------
                    weight:
                        dbRow.weight_a === "\\N" ||
                            !dbRow.weight_a
                            ? 0
                            : Number(
                                String(dbRow.weight_a)
                                    .replace("%", "")
                            ) / 100,

                    weightDisplay:
                        dbRow.weight_a === "\\N" ||
                            !dbRow.weight_a
                            ? ""
                            : dbRow.weight_a,

                    // -----------------------------
                    // Observations
                    // -----------------------------
                    observations:
                        dbRow
                            .no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                            ? ""
                            : dbRow
                                .no_of_observations_issues_non_compliance_delays_self_assesment_b ||
                            "",

                    // -----------------------------
                    // Impact
                    // -----------------------------
                    impact:
                        dbRow.impact_scale_of_1_to_10_c === "\\N"
                            ? ""
                            : dbRow.impact_scale_of_1_to_10_c || "",

                    // -----------------------------
                    // Index
                    // -----------------------------
                    index:
                        dbRow.index_a_b_c === "\\N"
                            ? 0
                            : Number(
                                dbRow.index_a_b_c || 0
                            )
                };
            });

        console.log(
            "UPDATED INDEX ROWS FROM TEMP:",
            updatedRows
        );

        setIndexRows(updatedRows);

        // =====================================================
        // UPDATE GRADE ROWS
        // TEMP DATA ONLY
        // =====================================================

        const tempGradeRows = records
            .filter(r =>
                r.score_grade &&
                r.score_grade !== "\\N" &&
                String(r.score_grade).trim() !== ""
            )
            .map(r => {

                // -----------------------------
                // Percentage
                // -----------------------------
                let percentage = "";

                if (
                    r.percentage_of_operational_risk_pillar_i_capital_charge !== "\\N" &&
                    r.percentage_of_operational_risk_pillar_i_capital_charge !== "" &&
                    r.percentage_of_operational_risk_pillar_i_capital_charge != null
                ) {
                    percentage =
                        Number(
                            String(
                                r.percentage_of_operational_risk_pillar_i_capital_charge
                            )
                                .replace("%", "")
                                .trim()
                        ) / 100;
                }

                return {

                    // -----------------------------
                    // Score Grade
                    // -----------------------------
                    scoreGrade:
                        String(r.score_grade).trim(),

                    // -----------------------------
                    // Min
                    // -----------------------------
                    min:
                        r.min !== "\\N" &&
                            r.min !== "" &&
                            r.min != null
                            ? Number(r.min)
                            : "",

                    // -----------------------------
                    // Max
                    // -----------------------------
                    max:
                        r.max !== "\\N" &&
                            r.max !== "" &&
                            r.max != null
                            ? Number(r.max)
                            : "",

                    // -----------------------------
                    // Percentage
                    // -----------------------------
                    percentage: percentage
                };
            });

        console.log(
            "===================================="
        );
        console.log(
            "TEMP GRADE ROWS:",
            tempGradeRows
        );
        console.log(
            "TEMP GRADE ROW COUNT:",
            tempGradeRows.length
        );
        console.log(
            "===================================="
        );

        // ---------------------------------------
        // TEMP has grade data
        // → use TEMP completely
        // ---------------------------------------
        if (tempGradeRows.length > 0) {

            console.log(
                "SETTING GRADE ROWS FROM TEMP"
            );

            setGradeRows(tempGradeRows);

        } else {

            // ---------------------------------------
            // No TEMP grade data
            // → keep Excel values
            // ---------------------------------------
            console.log(
                "NO TEMP GRADE DATA - USING EXCEL"
            );

            setGradeRows(initialGradeRows);
        }
        // Read only mode
        setIsViewMode(true);
    };

    useEffect(() => {

        loadReportingDateData(reportingDate);

    }, [reportingDate]);

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    const fetchPreviewData = async () => {
        try {

            const [tempResult, liveResult] = await Promise.all([
                fetchTableData("Risk_shariah_pillar1_temp"),
                fetchTableData("Risk_shariah_pillar1_live")
            ]);

            // If required
            setTempData(tempResult.data);
            setLiveData(liveResult.data);

            const dates = [
                ...new Set(
                    liveResult.data
                        .map(row => getQuarterFromReportingDate(row.reporting_date))
                        .filter(Boolean)
                )
            ];

            setReportingDates(dates);

        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const sortedReportingDates = [...reportingDates].sort((a, b) => {
        const [qA, yearA] = a.split("-");
        const [qB, yearB] = b.split("-");

        if (Number(yearA) !== Number(yearB)) {
            return Number(yearA) - Number(yearB);
        }

        return Number(qA.replace("Q", "")) - Number(qB.replace("Q", ""));
    });

    const str = (c) => (c == null ? "" : String(c).trim());

    const c1 = (row) => {
        if (!row || !Array.isArray(row)) return "";
        return str(row[1]);
    };

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };

    const loadShariahMapping = async (reportDate) => {
        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    dept: department,
                    tableName: "Shariah",
                    reportingDate: reportDate
                }
            };

            const response = await axios.post(
                shariahmappingdata,
                {},
                config
            );

            return response.data.data || [];

        } catch (err) {
            console.error(err);
            return [];
        }
    };

    const getQuarterFromReportingDate = (date) => {

        if (!date) return "";

        const [year, month] = date.split("-");

        switch (month) {
            case "03":
                return `Q1-${year}`;
            case "06":
                return `Q2-${year}`;
            case "09":
                return `Q3-${year}`;
            case "12":
                return `Q4-${year}`;
            default:
                return "";
        }
    };

    const handleCancel = () => {

        if (messageType === "success") {
            setMakerRemarks("");
            setIsViewMode(false);
        }

        setShowModal(false);
        setModalMessage("");
    };

    const loadExcel = async () => {
        try {
            const response = await fetch("/templates/sharaiah_template_sheet.xlsx");
            if (!response.ok) throw new Error("Unable to load Excel file.");

            const data = await response.arrayBuffer();
            // const workbook = XLSX.read(data, { type: "array" });
            const workbook = XLSX.read(data, {
                type: "array",
                cellText: true
            });
            const sheetName = "Shariah Risk (P 2) - Dec 25";
            const worksheet = workbook.Sheets[sheetName];
            if (!worksheet) { alert(`${sheetName} sheet not found`); return; }

            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: null,
                raw: true
            });

            // ── Helper: find the first row index where col1 matches a predicate ──
            const findRow = (predicate, from = 0) => {
                for (let i = from; i < rows.length; i++) {
                    const row = rows[i] || [];
                    if (predicate(row, i)) return i;
                }
                return -1;
            };

            const c1 = (row) => str(row[1]);

            // ── Locate landmark rows by content ──
            const iRow = findRow(r => r[0] === 1 && c1(r).toLowerCase().includes("name of risk"));
            const iSec2 = findRow(r => r[0] === 2);
            const iDefLabel = findRow(r => c1(r).toLowerCase().startsWith("definition"));
            const iSec3 = findRow(r => r[0] === 3 && c1(r).toLowerCase().includes("key areas"));
            const iSec4 = findRow(r => r[0] === 4 && c1(r).toLowerCase().includes("risk measurement"));
            const iIntro = findRow(r => c1(r).toLowerCase().includes("keeping in view"), iSec4);
            const iTableTitle = findRow(r => c1(r).toLowerCase().includes("computation of shariah"), iSec4);
            const iPeriod = findRow(r => c1(r).toLowerCase().startsWith("period"), iSec4);
            const iIdxHdr = findRow(r => c1(r).toLowerCase() === "key areas" && r[0] === null, iTableTitle);
            // const iTotalRow = findRow(r => (r[1] === null || r[1] === undefined || str(r[1]) === "") && typeof r[2] === "number", iIdxHdr + 1);
            const iTotalRow = findRow(
                r => {
                    const label = str(r[1]).toLowerCase();

                    return (
                        label.includes("total") ||
                        (label === "" && typeof r[2] === "number")
                    );
                },
                iIdxHdr + 1
            );
            const iGradeHdr = findRow(r => c1(r).toLowerCase() === "score grade", iTotalRow);
            const iPartHdr = findRow(r => c1(r).toLowerCase() === "particulars", iGradeHdr);
            const iQuarterHdr = findRow(r => [r[1], r[2], r[3], r[4]].some(c => /^Q\d-\d{4}$/i.test(str(c))), iPartHdr);
            const iQuarterVal = findRow(r => [r[1], r[2], r[3], r[4]].every(c => typeof c === "number"), iQuarterHdr + 1);
            const iFinalCap = findRow(r => c1(r).toLowerCase().includes("final capital charge"), iQuarterVal);

            // ── Extract each section ──

            // 1. Name of risk
            const rowNameOfRisk = rows[iRow] || [];
            const nameOfRisk = str(rowNameOfRisk[3]) || str(rowNameOfRisk[2]) || "";

            // 2. Summary
            const summary = iSec2 >= 0 ? c1(rows[iSec2]) : "";

            // 3. Definition
            const definition = iDefLabel >= 0 ? c1(rows[iDefLabel]) : "";
            const defTextRow = iDefLabel >= 0 ? findRow(r => c1(r).length > 10, iDefLabel + 1) : -1;
            const definitionText = defTextRow >= 0 ? c1(rows[defTextRow]) : "";

            // 4. Pillar
            const iPillar = findRow(r => c1(r).toUpperCase().includes("PILLAR"));
            const pillar = iPillar >= 0 ? c1(rows[iPillar]) : "";

            // 5. Key areas
            const keyAreasIntroRow = findRow(r => c1(r).toLowerCase().includes("the bank considers"), iSec3);
            const keyAreasIntro = keyAreasIntroRow >= 0 ? c1(rows[keyAreasIntroRow]) : "";
            const keyAreas = [];
            const keyEnd = iSec4 >= 0 ? iSec4 : rows.length;
            for (let i = (keyAreasIntroRow >= 0 ? keyAreasIntroRow + 1 : iSec3 + 1); i < keyEnd; i++) {
                const txt = c1(rows[i]);
                if (txt.length > 10) keyAreas.push(txt);
            }

            // 6. Risk measurement
            const heading = iSec4 >= 0 ? c1(rows[iSec4]) : "";
            const intro = iIntro >= 0 ? c1(rows[iIntro]) : "";
            const tableTitle = iTableTitle >= 0 ? c1(rows[iTableTitle]) : "";
            const period = iPeriod >= 0 ? c1(rows[iPeriod]) : "";

            // Index table headers (cols 1,2,3,5,7 — skip merged empty cols)
            const indexHeaders = iIdxHdr >= 0
                ? [rows[iIdxHdr][1], rows[iIdxHdr][2], rows[iIdxHdr][3], rows[iIdxHdr][5], rows[iIdxHdr][7]]
                    .map(h => str(h).replace(/\n/g, " "))
                : [];

            // setIndexRows(indexRows);
            const parsedIndexRows = [];

            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];

                    if (c1(r).length > 0) {
                        parsedIndexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,
                            observations: "",
                            impact: "",
                            index: 0
                        });
                    }
                }
            }

            setIndexRows(parsedIndexRows);
            setInitialIndexRows(parsedIndexRows.map(row => ({ ...row })));
            // Index table data rows (between header and total row)
            const indexRows = [];
            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        // indexRows.push([str(r[1]), r[2], r[3], r[5], r[7]]);
                        indexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,   // A
                            observations: "",            // B (editable)
                            impact: "",                  // C (editable)
                            index: 0                     // A * B * C
                        });
                    }
                }
            }

            // Index total row
            const indexTotal = iTotalRow >= 0
                ? { weight: rows[iTotalRow][2], index: rows[iTotalRow][7] }
                : null;

            // Grade table headers (cols 1,2,3,4,6 — skip merged col 5)
            const gradeHeaders = iGradeHdr >= 0
                ? [rows[iGradeHdr][1], rows[iGradeHdr][2], rows[iGradeHdr][3], rows[iGradeHdr][4], rows[iGradeHdr][6]]
                    .map(h => str(h))
                : [];

            // Grade rows (between grade header and particulars header)
            const parsedGradeRows = [];

            if (iGradeHdr >= 0 && iPartHdr >= 0) {
                for (let i = iGradeHdr + 1; i < iPartHdr; i++) {
                    const r = rows[i];

                    if (c1(r).length > 0) {
                        parsedGradeRows.push({
                            scoreGrade: str(r[1]),
                            min: Number(r[2]) || 0,
                            max: Number(r[3]) || 0,
                            percentage: Number(r[4]) || 0,
                            applicablePercentage: 0
                        });
                    }
                }
            }
            setGradeRows(parsedGradeRows);
            setInitialGradeRows(
                parsedGradeRows.map(row => ({ ...row }))
            );

            // Particulars rows (between particulars header and quarter header)
            const particularsRows = [];
            if (iPartHdr >= 0 && iQuarterHdr >= 0) {
                for (let i = iPartHdr + 1; i < iQuarterHdr; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        particularsRows.push({ label: c1(r), amount: r[3] });
                    }
                }
            }

            // Quarter headers and values
            const quarterHeaders = iQuarterHdr >= 0
                ? [rows[iQuarterHdr][1], rows[iQuarterHdr][2], rows[iQuarterHdr][3], rows[iQuarterHdr][4]].map(str)
                : [];
            const quarterValues = iQuarterVal >= 0
                ? [rows[iQuarterVal][1], rows[iQuarterVal][2], rows[iQuarterVal][3], rows[iQuarterVal][4]]
                : [];

            // Final capital charge
            const finalCapital = iFinalCap >= 0
                ? { label: c1(rows[iFinalCap]), val: rows[iFinalCap][5] }
                : null;

            setSheetData({
                pillar,
                nameOfRisk,
                summary,
                definition,
                definitionText,
                keyAreasIntro,
                keyAreas,
                riskMeasurement: {
                    heading,
                    intro,
                    tableTitle,
                    period,
                    indexHeaders,
                    indexRows: parsedIndexRows,
                    indexTotal,
                    gradeHeaders,
                    gradeRows: parsedGradeRows,
                    particularsRows,
                    quarterHeaders,
                    quarterValues,
                    finalCapital
                },
            });

            setExcelLoaded(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setExcelLoaded(true);
        }
    };

    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const totalWeight = indexRows.reduce(
        (sum, row) => sum + (Number(row.weight) || 0),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows = gradeRows.map((row) => ({
        ...row,
        applicablePercentage:
            totalIndex >= Number(row.min) &&
                totalIndex <= Number(row.max)
                ? Number(row.percentage)
                : 0
    }));

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => sum + (Number(row.applicablePercentage) || 0),
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) * totalApplicablePercentage
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };

    const displayedQuarterHeaders = getQuarterSequence(reportingDate);

    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeAmount;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const isSubmitEnabled =
        allowSubmit &&
        reportingDate !== "" &&
        operationalRiskCharge !== "" &&
        indexRows.every(
            row =>
                row.observations !== "" &&
                row.impact !== ""
        );

    const formatPercentTwoDecimal = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(2)}%`;
    };

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null) return "";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        return `${(Number(value || 0) * 100).toFixed(2)}%`;
    };

    const formatIndex = (value) => {
        if (value === "" || value == null) return "";

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
    };

    const handleReset = () => {
        setOperationalRiskCharge("");
        setQ1("");
        setQ2("");
        setQ3("");

        const resetRows = indexRows.map(row => ({
            ...row,
            observations: "",
            impact: "",
            index: 0
        }));

        setIndexRows(resetRows);
    };

    const getReportingDate = (quarter) => {
        if (!quarter) return "";

        const [q, year] = quarter.split("-");

        switch (q) {
            case "Q1":
                return `${year}-03-31`;
            case "Q2":
                return `${year}-06-30`;
            case "Q3":
                return `${year}-09-30`;
            case "Q4":
                return `${year}-12-31`;
            default:
                return "";
        }
    };

    const rejectColumns = [
        "reporting_date",
        "quarter4",
        "quarter3",
        "quarter2",
        "quarter1",
        "no_of_observations_issues_non_compliance_delays_self_assesment_b",
        "impact_scale_of_1_to_10_c",
        "amount"
    ];

    const handleColumnSelect = (e) => {

        setSelectedColumn(e.target.value);

        if (e.target.value !== "Others") {
            setOtherReason("");
        }
    };

    const handleOtherReasonChange = (e) => {
        setOtherReason(e.target.value);
    };

    const formatColumnLabel = (column) => {

        return column
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());

    };

    const isReasonRequired = selectedColumn === "Others";

    const isSubmitDisabled =
        !selectedColumn ||
        (isReasonRequired && !otherReason.trim());

    const handleReasonSubmit = () => {

        if (!selectedColumn) {

            setMessageType("warning");
            setModalMessage("Please select rejection reason.");
            setShowModal(true);

            return;
        }

        if (selectedColumn === "Others" && !otherReason.trim()) {

            setMessageType("warning");
            setModalMessage("Please enter rejection reason.");
            setShowModal(true);

            return;
        }

        let reason = "";

        if (selectedColumn === "DeleteRecord") {

            reason = otherReason.trim()
                ? otherReason.trim()
                : "Delete the record";

        }
        else if (selectedColumn === "Others") {

            reason = otherReason.trim();

        }
        else {

            reason = otherReason.trim()
                ? `${formatColumnLabel(selectedColumn)} is not correct : ${otherReason}`
                : `${formatColumnLabel(selectedColumn)} is not correct`;

        }

        setRejectedReason(reason);

        setShowRejectModal(false);

        callRejectApi(reason);

    };

    const createStatusJson = async (
        reportingDate,
        status,
        fileType
    ) => {

        const today = new Date().toISOString().split("T")[0];
        const userId = localStorage.getItem("userid");

        const tableNameWithJson = `10192_submit.json`;

        let statusData = [];

        try {
            const response = await fetch(`/jsonfiles/${tableNameWithJson}`);

            if (response.ok) {
                statusData = await response.json();
            }
        } catch (err) {
            console.log("No existing status file. Creating new one.");
        }

        // Remove existing record having same submitted_date
        statusData = statusData.filter(
            item => item.submitted_date !== today
        );

        const newStatus = {
            reporting_date: reportingDate,
            submitted_date: today,
            status: status,
            reported_by: "10192",
            reviewed_by: "10007"
        };

        // Latest record first
        statusData.unshift(newStatus);

        await axios.post(
            updatetextfile3001,
            {
                tableNameWithJson,
                content: JSON.stringify(statusData, null, 2)
            },
            {
                headers: {
                    userId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
            }
        );

        console.log(`${tableNameWithJson} updated successfully`);
    };

    const callRejectApi = async (reason) => {

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);
        console.log("Row IDs:", rowIds);
        // console.log("First Row ID:", rowIds[0]);

        try {

            const config = {

                headers: {

                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,

                },

                withCredentials: true,

                params: {
                    // rowId: rowIds,
                    tableName: "shariah_pillar1",
                    status: 0,
                    dataModel: "BDM",
                    rejectedReason: reason,
                    "Notifications": "IN",
                    isBulk: 1,
                    dept: department

                }

            };

            const response = await axios.post(
                checkboxreject,
                rowIds,   // <-- Send row IDs in the request body
                config
            );

            console.log("Row IDs1:", rowIds);
            // console.log("First Row ID:", rowIds[0]);
            console.log(response.data);

            if (response.data?.message === "Data Rejected") {

                setMessageType("success");
                setModalMessage(response.data.message || "Rejected Successfully");

                await createStatusJson(
                    reportDate,
                    "Pending for Maker Modification",
                    "reject"
                );

                await fetchPreviewData();

                setReportingDate("");
                setMakerRemarks("");
                handleReset();
                setIsViewMode(false);

                setShowDownload(false);   // <-- Hide download

            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Reject Failed");

            }

            setShowModal(true);
        }
        catch (error) {

            console.log(error);

            setMessageType("error");

            setModalMessage(

                error.response?.data?.message ||

                "Error while rejecting."

            );

            setShowModal(true);

        }

    };

    const handleBulkApprove = async () => {

        setShowConfirmApprove(false);

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);

        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: "shariah_pillar1",
                    status: 1,
                    dataModel: "BDM",
                    Notifications: "IN",
                    isBulk: 1,
                    dept: department,
                },
            };

            const response = await axios.post(
                checkboxapprove,   // <-- Bulk approve checkbox API
                rowIds,            // <-- Send row IDs in request body
                config
            );

            console.log(response.data);

            if (response.data?.message === "Data Approved") {

                setMessageType("success");
                setModalMessage(response.data.message || "Approved Successfully");

                await createStatusJson(
                    reportDate,
                    "Data Approved",
                    "approve"
                );
                await fetchPreviewData();

                setShowDownload(true);   // <-- Show Download button


            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Approval Failed");

            }

            setShowModal(true);

        } catch (error) {

            console.log(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                "Error while approving."
            );

            setShowModal(true);
        }
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };

    const handleDownload = async () => {
        const workbook = new ExcelJS.Workbook();

        const overviewSheet = workbook.addWorksheet("Shariah Risk Overview");
        const assessmentSheet = workbook.addWorksheet("Shariah Risk Assessment");

        // -----------------------------
        // Styles
        // -----------------------------
        const headerStyle = {
            font: {
                bold: true,
                color: { argb: "FFFFFFFF" },
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "1F4E78" },
            },
            alignment: {
                horizontal: "center",
                vertical: "middle",
                wrapText: true,
            },
            border: {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            },
        };

        const borderStyle = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };

        const totalStyle = {
            font: {
                bold: true,
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "D9D9D9" },
            },
            border: borderStyle,
        };

        // -----------------------------
        // Column Widths
        // -----------------------------
        overviewSheet.columns = [
            { width: 40 },
            { width: 18 },
            { width: 22 },
            { width: 18 },
            { width: 22 },
        ];

        // -----------------------------
        // Title
        // -----------------------------
        overviewSheet.mergeCells("A1:E1");

        const title = overviewSheet.getCell("A1");
        title.value = "Shariah Risk Measurement";
        title.font = {
            bold: true,
            size: 16,
        };
        title.alignment = {
            horizontal: "center",
        };

        overviewSheet.addRow([]);

        overviewSheet.addRow(["Reporting Date", reportingDate]);

        overviewSheet.addRow([]);

        // ===================================================
        // STATIC INFORMATION
        // ===================================================

        // 1. Name of Risk
        if (sheetData.nameOfRisk) {
            let row = overviewSheet.addRow(["1. Name of Risk"]);
            row.getCell(1).font = { bold: true, color: { argb: "1F4E78" } };

            row = overviewSheet.addRow([sheetData.nameOfRisk]);
            overviewSheet.addRow([]);
        }

        // 2. Summary
        if (sheetData.summary) {

            // Heading
            let row = overviewSheet.addRow(["2. Summary"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" }
            };

            // Summary text
            row = overviewSheet.addRow([sheetData.summary]);

            overviewSheet.mergeCells(`A${row.number}:E${row.number}`);
            console.log(overviewSheet.getCell(`A${row.number}`).isMerged);

            row.getCell(1).alignment = {
                wrapText: true,
                horizontal: "left",
                vertical: "top",
            };

            overviewSheet.addRow([]);
        }

        // 3. Definition
        if (sheetData.definition) {

            // Heading
            let row = overviewSheet.addRow([sheetData.definition]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Definition text
            row = overviewSheet.addRow([sheetData.definitionText]);

            // Merge across all columns
            overviewSheet.mergeCells(`A${row.number}:E${row.number}`);

            row.getCell(1).alignment = {
                wrapText: true,
                vertical: "top",
                horizontal: "left",
            };

            overviewSheet.addRow([]);
        }

        // 4. Key Areas of Risk
        if (sheetData.keyAreas.length > 0) {

            // Heading
            let row = overviewSheet.addRow(["3. Key Areas of Risk"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.keyAreasIntro) {
                row = overviewSheet.addRow([sheetData.keyAreasIntro]);

                overviewSheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            // Bullet points
            sheetData.keyAreas.forEach((area) => {

                const text =
                    typeof area === "string"
                        ? area
                        : JSON.stringify(area);

                const bulletRow = overviewSheet.addRow([`• ${text}`]);

                overviewSheet.mergeCells(`A${bulletRow.number}:E${bulletRow.number}`);

                bulletRow.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            });

            overviewSheet.addRow([]);
        }

        // 5. Risk Measurement
        // 5. Risk Measurement
        if (sheetData.riskMeasurement.heading) {

            // Heading
            let row = overviewSheet.addRow([
                `4. ${sheetData.riskMeasurement.heading}`,
            ]);

            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.riskMeasurement.intro) {
                row = overviewSheet.addRow([
                    sheetData.riskMeasurement.intro,
                ]);

                // Merge across all columns
                overviewSheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            overviewSheet.addRow([]);
        }

        assessmentSheet.columns = [
            { width: 40 },
            { width: 18 },
            { width: 22 },
            { width: 18 },
            { width: 22 },
        ];

        assessmentSheet.mergeCells("A1:E1");

        const assessmentTitle = assessmentSheet.getCell("A1");

        assessmentTitle.value = "Shariah Risk Assessment";
        assessmentTitle.font = {
            bold: true,
            size: 16,
        };

        assessmentTitle.alignment = {
            horizontal: "center",
        };

        assessmentSheet.addRow([]);
        assessmentSheet.addRow(["Reporting Date", reportingDate]);
        assessmentSheet.addRow([]);

        // ===================================================
        // TABLE 1
        // ===================================================

        const header1 = assessmentSheet.addRow([
            "Key Areas",
            "Weight(A)",
            "No. of Observations/Issues/Non-Compliance/Delays/Self Assesment (B)",
            "Impact (Scale of 1 to 10)(C)",
            "Index(A * B * C)",
        ]);

        header1.eachCell((cell) => {
            Object.assign(cell, {
                style: headerStyle,
            });
        });

        indexRows.forEach((r) => {
            const row = assessmentSheet.addRow([
                r.keyArea,
                Number(r.weight),
                Number(r.observations),
                Number(r.impact),
                r.index,
            ]);

            // Format Weight column as percentage
            row.getCell(2).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        const totalRow = assessmentSheet.addRow([
            "",
            Number(totalWeight),
            "",
            "",
            totalIndex,
        ]);

        // Format Total Weight as percentage
        totalRow.getCell(2).numFmt = "0.00%";

        totalRow.eachCell((cell) => {
            cell.font = totalStyle.font;
            cell.fill = totalStyle.fill;
            cell.border = totalStyle.border;
        });

        totalRow.getCell(2).numFmt = "0%";      // or "0.00%"

        assessmentSheet.addRow([]);

        // ===================================================
        // TABLE 2
        // ===================================================

        const header2 = assessmentSheet.addRow([
            "Score Grade",
            "Min",
            "Max",
            "Percentage (%) of Operational Risk Pillar I Capital Charge",
            "Applicable Percentage (%)",
        ]);

        header2.eachCell((cell) => {
            cell.style = headerStyle;
        });

        calculatedGradeRows.forEach((r) => {
            const row = assessmentSheet.addRow([
                r.scoreGrade,
                r.min,
                r.max,
                Number(r.percentage),
                Number(r.applicablePercentage),
            ]);

            row.getCell(4).numFmt = "0.00%";
            row.getCell(5).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        assessmentSheet.addRow([]);

        // ===================================================
        // TABLE 3
        // ===================================================

        const header3 = assessmentSheet.addRow([
            "Particulars",
            "Amount",
        ]);

        header3.eachCell((cell) => {
            cell.style = headerStyle;
        });

        [
            [
                "Operational Risk Pillar I Capital Charge",
                Number(operationalRiskCharge),
            ],
            [
                "Applicable % Capital Charge for Shariah Risk",
                totalApplicablePercentage,
            ],
            [
                "Capital Charge for Shariah Risk",
                capitalChargeForShariahRisk,
            ],
        ].forEach((item) => {
            const row = assessmentSheet.addRow(item);

            // Apply percentage format only to the Applicable % row
            if (item[0] === "Applicable % Capital Charge for Shariah Risk") {
                row.getCell(2).numFmt = "0.00%";
            }

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        assessmentSheet.addRow([]);

        // ===================================================
        // TABLE 4
        // ===================================================

        const displayedQuarterHeaders = getQuarterSequence(reportingDate);

        const header4 = assessmentSheet.addRow(displayedQuarterHeaders);

        header4.eachCell((cell) => {
            cell.style = headerStyle;
        });

        const quarterRow = assessmentSheet.addRow([
            Number(values[0]) || 0,
            Number(values[1]) || 0,
            Number(values[2]) || 0,
            Number(q4) || 0,
        ]);

        quarterRow.eachCell((cell) => {
            cell.border = borderStyle;
        });

        assessmentSheet.addRow([]);

        // ===================================================
        // FINAL CAPITAL
        // ===================================================

        assessmentSheet.mergeCells(`A${assessmentSheet.rowCount + 1}:D${assessmentSheet.rowCount + 1}`);

        const finalRow = assessmentSheet.getRow(assessmentSheet.rowCount + 1);

        finalRow.getCell(1).value = getFinalCapitalLabel(reportingDate);
        finalRow.getCell(5).value = finalCapitalCharge;

        finalRow.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: "FFFFFF" },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "0D6EFD" },
            };

            cell.border = borderStyle;
        });

        // -----------------------------
        // Download
        // -----------------------------

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Shariah_Risk_${reportingDate}.xlsx`
        );
    };

    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="row">

                                {loading && (
                                    <div className="loading-overlay">
                                        <UploadLoadingIcon />
                                    </div>
                                )}

                                {!sheetData ? (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            No Data Found
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card-header bg-primary text-white">
                                            <h5 className="mb-0">
                                                {sheetData.nameOfRisk}
                                            </h5>
                                        </div>

                                        <div className="row g-2">

                                            <div className="col-lg-4 col-md-12">
                                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                    <div className="card-body">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                            <div className="">
                                                                <GapsyShariahDescription />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* ── RIGHT col: tables ── */}
                                            <div className="col-lg-8 col-md-12">
                                                <div className="card h-100 shadow-sm">
                                                    <div className="card-body">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                            <div className="table-on-homepage-only">
                                                                <div className="p-3">

                                                                    {sheetData.riskMeasurement.tableTitle && (
                                                                        <div className="px-2 pt-2 mb-3">
                                                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                                                <h6 className="fw-bold text-primary mb-0">
                                                                                    {sheetData.riskMeasurement.tableTitle}
                                                                                </h6>

                                                                                <div className="d-flex align-items-center gap-3 flex-wrap">
                                                                                    <label
                                                                                        htmlFor="reportingDate"
                                                                                        className="fw-semibold mb-0 text-nowrap"
                                                                                    >
                                                                                        Reporting Date
                                                                                    </label>

                                                                                    <select
                                                                                        id="reportingDate"
                                                                                        className="form-select form-select-sm"
                                                                                        style={{ width: "150px" }}
                                                                                        value={reportingDate}
                                                                                        onChange={(e) => {

                                                                                            const value = e.target.value;

                                                                                            setReportingDate(value);

                                                                                            setShowDownload(false);   // Hide until next approval

                                                                                            setAllowSubmit(false);

                                                                                            loadReportingDateData(value);
                                                                                        }}
                                                                                    >
                                                                                        <option value="">Select</option>

                                                                                        {sortedReportingDates.map((item) => (
                                                                                            <option key={item} value={item}>
                                                                                                {item}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    {!isNullValue(makerRemarks) && (
                                                                                        <>
                                                                                            <label className="fw-semibold mb-0 text-nowrap">
                                                                                                Remarks
                                                                                            </label>

                                                                                            <span
                                                                                                className="text-danger fw-semibold"
                                                                                                style={{ maxWidth: "350px", wordBreak: "break-word" }}
                                                                                            >
                                                                                                {makerRemarks}
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                    {reportingDate && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success btn-sm"
                                                                                            disabled={!reportingDate}
                                                                                            onClick={handleDownload}
                                                                                        >
                                                                                            <i className="bi bi-download me-1"></i>
                                                                                            Download
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Table 1: Shariah Risk Index */}
                                                                    {sheetData.riskMeasurement.indexHeaders.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    {sheetData.riskMeasurement.indexHeaders.map((h, i) => (
                                                                                        <th
                                                                                            key={i}
                                                                                            style={{
                                                                                                whiteSpace: "normal",
                                                                                                lineHeight: "1.2",
                                                                                                verticalAlign: "middle",
                                                                                                textAlign: "center"
                                                                                            }}
                                                                                        >
                                                                                            {i === 2 ? (
                                                                                                <>
                                                                                                    No. of.
                                                                                                    <br />
                                                                                                    Observations (B)
                                                                                                </>
                                                                                            ) : i === 3 ? (
                                                                                                <>
                                                                                                    Impact
                                                                                                    <br />
                                                                                                    (Scale of 1 to 10) (C)
                                                                                                </>
                                                                                            ) : (
                                                                                                h
                                                                                            )}
                                                                                        </th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {indexRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td>{row.keyArea}</td>

                                                                                        <td>{fmt(row.weight)}</td>

                                                                                        <td>

                                                                                            {row.observations}

                                                                                        </td>

                                                                                        <td>
                                                                                            {row.impact}
                                                                                        </td>

                                                                                        {/* <td>{fmt(row.index)}</td> */}
                                                                                        <td>{formatIndex(row.index)}</td>
                                                                                    </tr>
                                                                                ))}

                                                                                <tr className="fw-bold table-secondary">
                                                                                    <td></td>
                                                                                    {/* <td>{fmt(totalWeight)}</td> */}
                                                                                    <td>{formatPercent(totalWeight)}</td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    {/* <td>{fmt(totalIndex)}</td> */}
                                                                                    <td>{formatIndex(totalIndex)}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 2: Score Grade */}
                                                                    {sheetData.riskMeasurement.gradeHeaders.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    {sheetData.riskMeasurement.gradeHeaders.map((h, i) => (
                                                                                        <th key={i}>{h}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {calculatedGradeRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td>{row.scoreGrade}</td>
                                                                                        <td>{row.min}</td>
                                                                                        <td>{row.max}</td>

                                                                                        {/* Read from Excel as-is */}
                                                                                        <td>{formatExcelPercent(row.percentage)}</td>

                                                                                        {/* Calculated value */}
                                                                                        <td>{formatApplicablePercent(row.applicablePercentage)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 3: Particulars */}
                                                                    {sheetData.riskMeasurement.particularsRows.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    <th>Particulars</th>
                                                                                    <th>Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {sheetData.riskMeasurement.particularsRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td className="text-start">{row.label}</td>

                                                                                        <td>
                                                                                            {ri === 0 ? (
                                                                                                <div className="text-center px-2 py-1">
                                                                                                    {operationalRiskCharge}
                                                                                                </div>
                                                                                            ) : ri === 1 ? (
                                                                                                formatPercentTwoDecimal(totalApplicablePercentage)
                                                                                            ) : (
                                                                                                fmt(capitalChargeAmount)
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 4: Quarterly Capital Charges */}
                                                                    {sheetData.riskMeasurement.quarterHeaders.length > 0 && (

                                                                        <table className="table table-bordered table-hover text-center">
                                                                            <thead>
                                                                                <tr>
                                                                                    {displayedQuarterHeaders.map((h, i) => (
                                                                                        <th key={i}>{h}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr>
                                                                                    {values.map((value, index) => {
                                                                                        const displayValue =
                                                                                            value === "" || value === null || value === undefined
                                                                                                ? 0
                                                                                                : fmt(value);

                                                                                        return (
                                                                                            <td key={index} className="text-end">
                                                                                                {index === 3 ? fmt(q4) : displayValue}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>

                                                                    )}

                                                                    {/* Final Capital Charge */}
                                                                    {sheetData.riskMeasurement.finalCapital && (
                                                                        <div className="mx-2 mt-3 mb-2">
                                                                            <div className="alert alert-primary d-flex justify-content-between align-items-center mb-0 py-2">
                                                                                <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
                                                                                    {getFinalCapitalLabel(reportingDate)}
                                                                                </span>
                                                                                <span className="fw-bold fs-6">
                                                                                    {fmt(finalCapitalCharge)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <Modal show={showConfirmApprove} onHide={() => setShowConfirmApprove(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        <p>Are you sure you want to Approve this record?</p>
                                    </Modal.Body >
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary"
                                            style={
                                                cancelButtonStyle
                                            } onClick={() => setShowConfirmApprove(false)}>Cancel</Button>
                                        <Button
                                            variant="Primary"
                                            style={submitButtonStyle}
                                            onClick={() => {
                                                setShowConfirmApprove(false);
                                                handleBulkApprove();
                                            }}
                                        >
                                            Submit
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal
                                    show={showModal}
                                    onHide={handleCancel}
                                    style={{ marginTop: '12vh' }}
                                >
                                    <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                        style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                        <div className="d-flex align-items-center">
                                            {messageType === 'success' ? (
                                                <span className="me-2" style={{ color: 'green' }}>✅</span>
                                            ) : (
                                                <span className="me-2" style={{ color: 'red' }}>❌</span>
                                            )}
                                            <p
                                                style={{
                                                    marginBottom: '0px',
                                                    color: messageType === 'success' ? 'green' : 'red',
                                                    fontSize: '14px',
                                                    whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: modalMessage.replace(/\n/g, '<br />')
                                                }}
                                            ></p>



                                        </div>
                                        <button
                                            type="button"
                                            className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                            onClick={handleCancel}>
                                        </button>

                                    </div>
                                </Modal>
                                <Modal
                                    show={showRejectModal}
                                    onHide={() => setShowRejectModal(false)}
                                    backdrop="static"
                                    keyboard={false}
                                    size="lg"
                                    style={{ marginTop: '12vh' }}
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        <div className="form-group">
                                            <label htmlFor="column-select" className="text-secondary">Select Reason</label>

                                            <select
                                                className="form-control"
                                                id="column-select"
                                                onChange={handleColumnSelect}
                                                value={selectedColumn}
                                            >
                                                <option value="">Select Reason</option>

                                                {rejectColumns
                                                    .filter(column => column !== "Maker_Remarks")
                                                    .map((column, index) => (
                                                        <option key={index} value={column}>
                                                            {formatColumnLabel(column)} is not correct
                                                        </option>
                                                    ))}

                                                <option value="DeleteRecord">Delete the record</option>
                                                <option value="Others">Others</option>
                                            </select>

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="reason-input"
                                                id="other-reason"
                                                value={otherReason}
                                                onChange={handleOtherReasonChange}
                                                placeholder="Provide Reason here..."
                                                required={isReasonRequired}
                                            />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button
                                            variant="secondary"
                                            onClick={() => setShowRejectModal(false)}
                                            style={cancelButtonStyle}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={handleReasonSubmit}
                                            disabled={isSubmitDisabled}

                                            style={
                                                ProceedButtonStyle
                                            }
                                        >
                                            Proceed
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal
                                    show={showReportingModal}
                                    onHide={() => {
                                        setShowReportingModal(false);
                                        setReportingDate("");
                                        setAllowSubmit(false);
                                    }}
                                    backdrop="static"
                                    keyboard={false}
                                    style={{ marginTop: "12vh" }}
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>
                                            Reporting Date Validation
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        {reportingMessage}
                                    </Modal.Body>

                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button
                                            variant="Primary"
                                            style={
                                                submitButtonStyle
                                            }
                                            onClick={() => {
                                                setShowReportingModal(false);
                                                setReportingDate("");
                                                setAllowSubmit(false);
                                            }}
                                        >
                                            OK
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyShariahReport;